/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUnderinsuredMotorist32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M28.75 2.5l-25 28'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M11.927 20.907a6.004 6.004 0 01-.335-8.48 6.004 6.004 0 018.479-.334'
      />
      <path
        stroke='currentColor'
        strokeDasharray='4 4'
        strokeLinecap='square'
        strokeMiterlimit={16}
        strokeWidth={1.5}
        d='M20.074 12.093a6.004 6.004 0 01.335 8.479 6.004 6.004 0 01-8.48.335'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M16.25 2.5l1.944 1.727a14.764 14.764 0 006.16 3.271M16.25 2.5l-1.944 1.727a14.766 14.766 0 01-8.888 3.7L4.25 8v7.382c0 3.629 1.41 7.064 3.85 9.627'
      />
      <path
        stroke='currentColor'
        strokeDasharray='4 4'
        strokeLinecap='square'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M10.908 27.279c2.213 1.394 4.112 2.558 5.343 3.221 1.232-.663 3.13-1.827 5.343-3.221a13.96 13.96 0 006.657-11.897V8l-1.168-.073a14.757 14.757 0 01-2.728-.429'
      />
    </svg>
  );
}

export default SvgUnderinsuredMotorist32;
